import CardHolderType from "enums/CardHolderType";
import PlatformIntegrationCategory from "enums/PlatformIntegrationCategory";

export const CATEGORY_LABEL_KEY: Record<PlatformIntegrationCategory, string> = {
  [PlatformIntegrationCategory.CARD_ISSUING]: "Card issuing",
  [PlatformIntegrationCategory.ACQUIRING]: "Acquiring",
};

export const CARD_HOLDER_LABEL_KEY: Record<CardHolderType, string> = {
  [CardHolderType.AUTHORIZED_USER]: "Authorized users",
  [CardHolderType.BUSINESS]: "Business",
};
